import axios from "axios";

export const loadCarYears = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("https://api.tintworld.com/v1/vehicles/getYears/")
      .then(function (response) {
        commit("setCarYears", response.data.years);
        resolve();
      })
      .catch(function (e) {
        reject(e);
      });
  });
};
export const getDealsMenus = ({ commit }) => {
  axios.get('https://tintworld.com/wp-json/tint-world-api/v1/get-deals-menu')
      .then(function(response){
        commit("setDeals", response.data);
  });
};
export const loadCarMakes = ({ commit }, year) => {
  axios
    .get("https://api.tintworld.com/v1/vehicles/getMakes/" + year)
    .then(function (response) {
      commit("setCarMakes", response.data.vehicles);
    });
};
export const loadFormServices = ({ commit }) => {
  axios
    .get("https://sync.tintworld.com/query/form-store-services")
    .then(function (response) {
      commit("setFormServices", response.data);
    });
};
export const getAvailability = ({ commit }, storeID) => {
  //@TODO - If user has a selected availability date, we should consider doing a re-query regardless (and handling via API)
  return new Promise((resolve, reject) => {
    axios
      .get(
        "https://sync.tintworld.com/query/appointments/availability?storeID=" +
          storeID
      )
      .then(function (response) {
        commit("setInitialAvailability", response.data.availability);
        commit("setAvailabilityQuery");
        resolve();
      })
      .catch(function (e) {
        //@TODO - Add function to retry on failure
        reject(e);
      });
  });
};
export const addAvailability = ({ commit, getters }, lastQueryDate) => {
  //@TODO - If user has a selected availability date, we should consider doing a re-query regardless (and handling via API)
  return new Promise((resolve, reject) => {
    axios
      .get(
        "https://sync.tintworld.com/query/appointments/availability?storeID=" +
          getters.formStore.id +
          "&from=" +
          lastQueryDate
      )
      .then(function (response) {
        commit("addAvailabilityDates", response.data.availability);
        resolve();
      })
      .catch(function (e) {
        //@TODO - Add function to retry on failure
        reject(e);
      });
  });
};

export const getGeoResults = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    formData.append("location-search", data.search["location-search"]);
    axios
      .post(`https://sync.tintworld.com/api/store-locator`, formData)
      .then(function (response) {
        let searchData = response.data;
        commit("updateUserSearchResults", {
          search_results: searchData["nearby-locations"],
        });
        //@TODO - May need to ensure the below data is valid before commiting
        commit("updateUserSearchLocation", {
          lat: searchData["search-location"].latitude,
          lng: searchData["search-location"].longitude,
          city: searchData["search-location"].address.city,
          region: searchData["search-location"].address.region,
        });
        resolve();
      })
      .catch(function (e) {
        reject(e);
      });
    ////@TODO - Add function to retry on failure
  });
};
export const geolocateStores = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    formData.append("location-search", data.search["location-search"]);
    axios
      .post(`https://sync.tintworld.com/api/store-locator`, formData)
      .then(function (response) {
        commit("updateUserSearchResults", {
          search_results: response.data["nearby-locations"],
        });
        resolve();
      })
      .catch(function (e) {
        reject(e);
      });
    ////@TODO - Add function to retry on failure
  });
};
export const autoLocateUser = ({ commit, dispatch }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("https://ipinfo.io/?token=762408ef747fbe")
      .then(function (response) {
        var geo = response.data.loc.split(",");
        var lat = geo[0];
        var long = geo[1];
        var userLocation = response.data;
        var sel_city = userLocation.city;
        var sel_location = userLocation.region;
        //var search_parameters = {search: { ["location-search"]: sel_city + ", " + sel_location }};
        commit("setUserAutoLocation", {
          lat: lat,
          lng: long,
          city: sel_city,
          region: sel_location,
        });
        dispatch("getGeoResults", {
          search: { ["location-search"]: sel_city + ", " + sel_location },
        });
        resolve();
      })
      .catch(function (e) {
        reject(e);
      });
  });
};
export const queryPPCAvailability = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    //console.log(data);
    //let formData = new FormData();
    //formData.append('location-search',data.search['location-search']);
    axios
      .get(
        `https://sync.tintworld.com/query/appointments/availability/ppc?storeID=` +
          state.user.ppc_store
      )
      .then(function (response) {
        commit("setInitialPPCAvailability", {
          disabled_dates: response.data.dates,
          disabled_to: response.data.to,
          disabled_from: response.data.from,
        });
        resolve();
      })
      .catch(function (e) {
        //console.log(e);
        reject(e);
      });
    ////@TODO - Add function to retry on failure
  });
};
export const updatePPCAvailability = ({ commit, state }, data) => {
  return new Promise((resolve, reject) => {
    //console.log(data);
    //let formData = new FormData();
    //formData.append('storeID',data.search['location-search']);
    let queryDate = new Date(data.from).toJSON();
    axios
      .get(
        "https://sync.tintworld.com/query/appointments/availability/ppc?from=" +
          queryDate +
          "&storeID=" +
          state.user.ppc_store
      )
      .then(function (response) {
        commit("updatePPCAvailability", {
          disabled_dates: response.data.dates,
          disabled_from: response.data.from,
        });
        resolve();
      })
      .catch(function (e) {
        //console.log(e);
        reject(e);
      });
    ////@TODO - Add function to retry on failure
  });
};
export const updateNonVehicleOptions = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.tintworld.com/v1/appointment/service-options/`)
      .then(function (response) {
        commit("setApptModels", response.data);
        commit("setQuoteModels", response.data);
        resolve();
      })
      .catch(function (e) {
        reject(e);
      });
  });
};

export const getCoupons = async ({ commit }) => {
  try {
    const response = await axios.get(
      "https://sync.tintworld.com/api/v2/get-affiliate?affiliate_id=1"
    );
    commit("setAllCoupons", response.data.assigned_coupons);
    commit("setCouponData", response.data);
  } catch (err) {
    console.error(err);
  }
};
export const loadCurrentPageStorePromotion = ({ commit }, data) => {
  //@TODO - Need to pass through ident here?
  //@TODO - Should likely add some basic logic below
  if (
    typeof data.storeId === "undefined" &&
    typeof data.promotionId === "undefined"
  ) {
    return false;
  }
  return new Promise((resolve, reject) => {
    //@TODO - Currently not sending with a responseCode, so we'll likely need to determine based off a 404 header to reject / pivot on functionality
    axios
      .get(
        "https://sync.tintworld.com/api/v2/store-promotion?store_id=" +
          data.storeId +
          "&promotion_id=" +
          data.promotionId
      )
      .then(function (response) {
        console.log(response);
        if (response.status == 200) {
          commit("setCurrentPageStorePromotion", response.data.data);
          resolve();
        }
      })
      .catch(function (error) {
        if (error.response.status == 500) {
          commit("resetCurrentPageStoreCoupons");
          //@TODO - Clear Coupons
          reject();
        }
        if (error.response.status == 404) {
          commit("resetCurrentPageStoreCoupons");
          reject();
        }
      });
  });
};
export const loadPagePromotion = ({ commit }, promotionId) => {
  //@TODO - Need to pass through ident here?
  //@TODO - Should likely add some basic logic below
  if (typeof promotionId === "undefined" || promotionId === "undefined") {
    return false;
  }
  return new Promise((resolve, reject) => {
    //@TODO - Currently not sending with a responseCode, so we'll likely need to determine based off a 404 header to reject / pivot on functionality
    axios
      .get(
        "https://sync.tintworld.com/api/v2/store-promotion?promotion_id=" +
          promotionId
      )
      .then(function (response) {
        if (response.status == 200) {
          commit("setCurrentPagePromotion", response.data);
          resolve();
        }
      })
      .catch(function (error) {
        if (error.response.status == 500) {
          commit("resetCurrentPageStoreCoupons");
          //@TODO - Clear Coupons
          reject();
        }
        if (error.response.status == 404) {
          commit("resetCurrentPageStoreCoupons");
          reject();
        }
      });
  });
};
export const loadCurrentPromotion = ({ commit }, storeId) => {
  console.log(storeId);
  if (typeof storeId === "undefined" || storeId === "undefined") {
    return false;
  }
  //@TODO - Need to pass through ident here?
  //@TODO - Should likely add some basic logic below
  return new Promise((resolve, reject) => {
    //@TODO - Currently not sending with a responseCode, so we'll likely need to determine based off a 404 header to reject / pivot on functionality

    axios
      .get(
        "https://sync.tintworld.com/api/v2/store-promotion?store_id=" + storeId
      )
      .then(function (response) {
        commit("setCurrentPromotion", response.data.data);
        resolve();
      })
      .catch(function (error) {
        if (error.response.status == 404) {
          commit("resetCurrentPromotionCoupons");
          reject();
        }
      });
  });
};
export const loadStorePromos = ({ commit }, storeId) => {
  //@TODO - Need to pass through ident here?
  //@TODO - Should likely add some basic logic below

  if (typeof storeId === "undefined" || storeId === "undefined") {
    return false;
  }
  return new Promise((resolve, reject) => {
    //@TODO - Currently not sending with a responseCode, so we'll likely need to determine based off a 404 header to reject / pivot on functionality
    axios
      .get(
        "https://sync.tintworld.com/api/v2/store-promotion?store_id=" + storeId
      )
      .then(function (response) {
        if (response.status == 200) {
          commit("setStorePromos", response.data.data);
          resolve();
        }
        if (response.status == 500) {
          console.log("API Error.");
          reject();
        }
        if (response.status == 404) {
          console.log("No Data or Results For Currently Selected Store");
          //@TODO - Clear Coupons
          reject();
        }
      });
  });
};

export const submitAffiliateLead = async ({ commit, getters }) => {
  const data = getters.affiliateFormData;
  commit("setFormProcessing", true);
  commit("appointmentValidationFailed", false);
  try {
    const response = await axios.post(
      "https://sync.tintworld.com/api/v2/affiliate-quote",
      data
    );
    if (response.status == 200) {
      commit("setAffiliateComplete", true);
      commit("setAffiliateErrors", null);
      commit("setResponse", {
        responseCode: response.data.responseCode,
        responseHeadline: response.data.headline,
        responseMessage: response.data.message,
        responseDetails: response.data.details,
        transactionID: response.data.transactionID,
      });
    }
  } catch (err) {
    if (err?.response?.status == 422) {
      commit("setAffiliateErrors", err.response.data.errors);
    }
  }
};
export const submitLead = ({ commit, getters }, formType) => {
  //@TODO - Can also update the state for the transaction, and update it throughout the process / handle errors / determine how we're going to redirect the user
  //@TODO - Should we let server handle all validations, or handle init validate via Vue? Might need to test / log initially to determine areas of improvement

  //@TODO - We should consider revising the message and/or passing the 'success / store phone' via the Response, so we can have one single source of truth
  return new Promise((resolve, reject) => {
    //let formType = getters.userCurrentForm;
    commit("toggleFormCriticalError", false);
    let data = null;
    if (formType == "appointment") {
      data = getters.appointmentFormData;
    }
    if (formType == "ppc") {
      data = getters.ppcFormData;
    }
    if (formType == "quote") {
      data = getters.quoteFormData;
    }

    if (data == null) {
      commit("toggleFormCriticalError", true);
      reject();
    }
    commit("setFormProcessing", true);
    commit("appointmentValidationFailed", false);
    //axios.post('http://localhost/leads/new',data)
    axios
      .post("https://sync.tintworld.com/leads/new", data)
      .then(function (response) {
        commit("setFormProcessing", false);
        if (response.data.responseCode == 0) {
          commit("setResponse", {
            responseCode: response.data.responseCode,
            responseErrors: response.data.errors,
          });
        }
        if (response.data.responseCode == 2) {
          commit("setResponse", {
            responseCode: response.data.responseCode,
            responseErrors: response.data.errors,
          });
          commit("appointmentValidationFailed", true);
          commit("resetAppointment");
          if (formType == "appointment") {
            commit("FormStepBack", {
              type: "appointment",
              change: "go_to",
              go_to: 2,
            });
          }
        }
        if (response.data.responseCode == 1) {
          commit("setResponse", {
            responseCode: response.data.responseCode,
            responseHeadline: response.data.headline,
            responseMessage: response.data.message,
            responseDetails: response.data.details,
            transactionID: response.data.transactionID,
          });
          commit("setUserID", response.data.data.id);
        }
        resolve();
      })
      .catch((error) => {
        commit("setFormProcessing", false);
        if (error.response.status == 422) {
          commit("processErrors", {
            formType: formType,
            errors: error.response.data.errors,
          });
        }
        if (error.response.status == 500) {
          commit("toggleFormCriticalError", true);
        }
        reject(error.response.data);
      });
  });
};
